export const TEST_ID = 'lifecycleLogLine';
